import '../../Admin.scss';
import '../../../../styles/_table.scss';

import { Table, TableBody, TableCell, TableHead, TableRow } from '@trackman/web-shared-components';
import { useCallback, useEffect, useMemo, useState } from 'react';

import { DefaultRoutes } from 'Routes';
import DeleteListItemModal from 'components/Admin/Modals/DeleteListItemModal/DeleteListItemModal';
import HeaderCreateButton from 'components/Admin/HeaderCreateButton/HeaderCreateButton';
import HeaderSearchbar from 'components/Admin/HeaderSearchbar/HeaderSearchbar';
import { Link } from 'react-router-dom';
import Paragraph from 'components/TextComps/Paragraph';
import { PartnerOrMaster } from 'types/partner';
import { ReactComponent as PencilIcon } from 'images/icons/Pencil.svg';
import SortOrderButton from 'components/SortOrderButton/SortOrderButton';
import { ReactComponent as TrashIcon } from 'images/icons/Trash.svg';
import { observer } from 'mobx-react-lite';
import { sortByString } from 'utilities/dataSorters';
import useSetPageTitle from 'utilities/useSetPageTitle';
import { useStores } from 'index';

type RowsDisplay = {
  id: string;
  fullName: string;
};

export const MastersList = observer(() => {
  useSetPageTitle({ title: 'Masters List', subtitle: '' });
  const ms = useStores().mastersStore;
  const mes = useStores().mastersEditorStore;
  const [isModalOn, setIsModalOn] = useState(false);
  const [sortOrder, setSortOrder] = useState<'ASCENDING' | 'DESCENDING'>('ASCENDING');

  useEffect(() => {
    typeof ms.masters[0] === 'number' && ms.getMasters();
    setSortOrder('ASCENDING');
  }, [ms]);

  useEffect(() => {
    if (typeof ms.masters[0] !== 'number' && 'fullName' in ms.masters[0]) {
      let filteredList = (ms.masters as PartnerOrMaster[]).filter((master) =>
        master.fullName.toLowerCase().includes(ms.searchValue.toLowerCase())
      );

      filteredList = sortByString(filteredList, 'fullName', sortOrder);

      ms.filteredList = filteredList;
    }
  }, [ms, ms.searchValue, sortOrder]);

  const rowsDisplay: RowsDisplay[] = useMemo(
    () =>
      ms.filteredList.map((master) => {
        return {
          id: master.id,
          fullName: master.fullName,
        };
      }) as RowsDisplay[],
    [ms.filteredList]
  );

  const deleteMaster = useCallback(() => {
    mes.selectedMaster.id && mes.deleteMaster(mes.selectedMaster.id);
    setIsModalOn(false);
  }, [mes, setIsModalOn]);

  return (
    <div className='admin-content-container'>
      <div className='admin-list-header'>
        <HeaderSearchbar searchValue={ms.searchValue} onChange={ms.setSearchValue} />
        <HeaderCreateButton buttonTitle='New master' route={DefaultRoutes.MastersEditor} />
      </div>

      <div className='tmu-table-wrapper'>
        <Table className='tmu-table admin-table'>
          <TableHead>
            <TableRow>
              <TableCell>
                Name
                <SortOrderButton isActive={true} sortOrder={sortOrder} onSortChange={(sortOrder) => setSortOrder(sortOrder)} />
              </TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsDisplay.length ? (
              rowsDisplay.map((row) => {
                return (
                  <TableRow hover tabIndex={-1} key={row.id}>
                    <TableCell>{row.fullName}</TableCell>
                    <TableCell>
                      <div className='action-buttons'>
                        <Link to={`/Admin/${DefaultRoutes.MastersEditor}/${row.id}`} className='row-button'>
                          <PencilIcon />
                        </Link>
                        <button
                          className={`row-button ${mes.isLoading ? 'disabled' : ''}`}
                          onClick={() => {
                            mes.selectedMaster.id = row.id;
                            setIsModalOn(true);
                          }}
                          disabled={mes.isLoading}
                        >
                          <TrashIcon />
                        </button>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={3}>
                  <Paragraph>
                    <>No masters found</>
                  </Paragraph>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
      <DeleteListItemModal isModalOn={isModalOn} setIsModalOn={setIsModalOn} deleteAction={deleteMaster} itemName='master' />
    </div>
  );
});

export default MastersList;
